<template>
    <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
            <label class="form-label md:text-right md:mb-0" for="name">{{label}}:</label>
        </div>
        <div class="md:w-2/3">
            <div v-if="required===true">
                <div v-if="autofocus===true">
                    <input class="form-input" name="name" :type="type" v-model="store[field]" required autofocus>
                </div>
                <div v-else>
                    <input class="form-input" name="name" :type="type" v-model="store[field]" required>
                </div>
            </div>
            <div v-else>
                <input class="form-input" name="name" :type="type" v-model="store[field]">
            </div>
            <span class="text-red-dark text-xs pl-4" v-if="store.errors.has(field)" v-text="store.errors.get(field)"></span>
        </div>
    </div>
</template>
<script>
    import store from './store.js'

    export default {
        props: ['label', 'field', 'type', 'required', 'autofocus'],
        data() { return { store: store } }
    }
</script>
